import { InsurancePolicy } from '@/types/insurancePolicy';

const insurancePolicyFieldsForCompletion: Array<keyof InsurancePolicy> = [
  'carrier',
  'plan',
  'type',
  'subscriber_id',
  'priority_type',
  'relationship'
];

export default insurancePolicyFieldsForCompletion;
